import { useLocation } from "react-router-dom";

/**
 * The page title. ONE string, said ONCE.
 *
 * This used to return an uppercase kicker, a heading AND a subtitle, and the chrome painted
 * all three on every route — "REVIEW / Approval review / Approve edits, run final QA, and
 * package only when checks pass." Three restatements of one fact, above a screen that then
 * said the same thing again in its own panels. That is the over-explanation the redesign
 * exists to kill, and it is also 90px of a 390px phone spent on chrome before the work.
 *
 * The title now does exactly two jobs, and no others:
 *   - it labels the page in the top bar, and
 *   - it is the <h1> that route-change focus lands on and the live region announces.
 * The screens carry their own context (the editor names the document, the review names the
 * organization); the chrome does not need to repeat it, and must not.
 */
export function usePageMeta() {
  const path = useLocation().pathname;

  /* "Draft" and "Review" — the two STAGE names the run flow uses, not two nouns invented for
     the chrome. The tab, the flow bar, the menu and this heading now all say the same word
     for the same surface, so an operator can connect what they tapped to where they landed. */
  if (path.includes("/editor")) return { title: "Draft" };
  if (path.includes("/review")) return { title: "Review" };
  if (path === "/runs") return { title: "Library" };
  if (path === "/pipeline") return { title: "Pipeline" };
  if (path === "/settings") return { title: "Settings" };
  if (path === "/help") return { title: "Help" };
  return { title: "New run" };
}
